var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-layout",
            {
              class: {
                column: _vm.$vuetify.breakpoint.mdAndDown,
                row: _vm.$vuetify.breakpoint.lgAndUp,
              },
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg4: "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "pb-0",
                          attrs: { flat: "", color: "secondary" },
                        },
                        [_c("h4", [_vm._v("Company Details")])]
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [_vm._v("Location")]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v(
                                  "Intershore Chambers, Road Town, Tortola, VG1110, British Virgin Islands"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v("Phone | Swiss Number"),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v("+41 225349859"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v("Copyrights Website Imprint"),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "copyrighted-badge",
                                    attrs: {
                                      title:
                                        "Copyrighted.com Registered & Protected",
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://www.copyrighted.com/website/C7M74ZizUcH19Gq9",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        alt: "Copyrighted.com Registered & Protected",
                                        border: "0",
                                        width: "125",
                                        height: "25",
                                        srcset:
                                          "https://static.copyrighted.com/badges/125x25/02_2_2x.png" +
                                          " 2x",
                                        src: "https://static.copyrighted.com/badges/125x25/02_2.png",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v("Copyrights Game Imprint"),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "copyrighted-badge",
                                    attrs: {
                                      title:
                                        "Copyrighted.com Registered & Protected",
                                      target: "_blank",
                                      href: "https://www.copyrighted.com/work/gn5TI3TX7YTkusGP",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        alt: "Copyrighted.com Registered & Protected",
                                        border: "0",
                                        width: "125",
                                        height: "25",
                                        rel: "noopener noreferrer",
                                        srcset:
                                          "https://static.copyrighted.com/badges/125x25/02_2_2x.png" +
                                          " 2x",
                                        src: "https://static.copyrighted.com/badges/125x25/02_2.png",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-app-bar",
                        {
                          attrs: {
                            flat: "",
                            color: "secondary",
                            role: "heading",
                            "aria-level": "1",
                          },
                        },
                        [_c("v-app-bar-title", [_vm._v("Terms & Conditions")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY. BY ACCESSING OR USING THIS WEBSITE OR DOWNLOADING ANY GAMES, YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS DESCRIBED HEREIN AND ALL TERMS INCORPORATED BY REFERENCE. IF YOU DO NOT AGREE TO ALL OF THESE TERMS, DO NOT USE THIS WEBSITE OR THE GAMES."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          'RedArc Studio, Ltd would like to thank you for visiting our website. This document contains the terms and conditions ("Terms") for governing your access to, and use of, the our Website located at www.goz.fun (or any subsequent URL which may replace it) and all officially associated websites and micro-sites (collectively, the "Website"), any games operated by us through the Website (the "Games"), and all features, functions software and services offered through this Website. The Website, the Games and the features, functions, software and services offered through this Website collectively constitute the "Service."'
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            1 Legal Agreement\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.1 These Terms constitute a legal agreement (“Agreement”) between you and RedArc Studio Limited, a limited liability company organized under the laws of British Virigin Islands (hereinafter: “REDARC”)."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.2 In this Agreement, the terms “we/us/our” means RedArc Studio Limited “You/your” means you as a user of the Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.3 If you reside in a country within the European Union (hereinafter: “the EU”), these terms are an agreement between you and AMWGE. If you reside in a country outside the EU, these terms do not apply to you and, before using the Service or any part of the Service, you must review and agree to the Terms applicable to users in the United States. In that case the Service will be delivered by RedArc Studio, Ltd. directly. RedArc Studio, Ltd. (“REDARC”) is a subsidiary company of AMWGE who owns and delivers the Service as a subcontractor to AMWGE."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.4 Your using the Service shall constitute your agreement to accept and be bound by the terms and conditions appearing in these Terms, and your agreement to comply with any Rules of Conduct posted on the Website or otherwise provided to you by AMWGE (the “Rules of Conduct”) and any end-user license agreement (“EULA”) applicable to our Game software or other software that we may provide in connection with the Service. All user identities created on the Website are governed by these Terms. This includes, but is not limited to, proper in-game and out-of-game conduct relating to the Game."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.5 If you do not agree with any of the Terms, please do not access or otherwise use the Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.6 You hereby represent that you have the legal capacity to enter into this Agreement and you are not barred from receiving the Service under the laws of the country you reside in."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.7 You understand and agree that the Service may include service announcements and administrative messages and you may not have the right to opt out of receiving them."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "1.8 This Agreement is in addition to, and does not in any way replace or supplant, any EULA or any additional terms and conditions that may apply when you use or purchase certain other AMWGE products, services, affiliate services, third-party content or third-party software. In the event the contents of this Agreement is contrary to one or more provisions of any other specific agreement or terms or conditions, the provision(s) of the specific Agreement, terms or conditions shall prevail."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            2 Changes to terms\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "2.1 We may amend and/or modify these Terms, the Rules of Conduct, and any EULA at any time in our sole discretion."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "2.2 Amendments and modifications to the Terms will be published on the Website and shall be effective immediately after publishing them on the Website, or a copy of amendments or modification will otherwise be provided to you. To the extent that it is legally permitted according to the law in the member state of the EU you reside in, you waive any right you may have to receive specific notice of such changes or modifications. When using an Account the amendments and modification to the Terms become effective upon acceptance."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "2.3 You are responsible for checking the Terms, the Rules of Conduct and any EULA periodically so you will be familiar with their contents as they may be amended or modified from time to time. By continuing to use any portion of the Service, you are already signifying your acceptance of any revised or updated terms. If you do not agree to the amended terms, you must stop using the Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            3 Description\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "3.1 AMWGE provides free-to-play, multi-player online Games to registered users and related features, functions and services available through the Website, such as community forums and other interactive areas. To access our Games, you may be required to download and install certain client software, and such access entails the use of hardware, software and Internet access (which you acknowledge play a crucial role in your user experience)."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "3.2 You agree that we are not responsible for any hardware, software or Internet access, quality, suitability or unavailability issues. We do not provide Internet access, and you are responsible for all fees relating to telephone and Internet access charges along with all necessary equipment, servicing, repair or correction incurred in maintaining connectivity to the servers."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            4 Account\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.1 You may be required to create an account (an “Account”) to access our Service and to use certain features and functions of our Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.2 You must be 13 years of age or older to create an Account. If you are 13 or over, but are under the legal age to enter into a contract in the jurisdiction you reside in (“Legal Age”) and/or under 18 years of age, we require that you review these Terms with your parents or (legal) guardian to ensure they read and agree to them. If you are the parent or (legal) guardian of a user of our Website, Games and/or Service and you have questions about the Terms, please contact us at amwgoz@goz.fun."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.3 By creating an Account or otherwise using the Service, you represent that you are of Legal Age or at least age 18 and agree to these Terms, or that you are over 13 years of age and your parents or legal guardian have read and agreed to these Terms, and you understand and agree that we are relying upon that representation in allowing you to use the Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.4 Notwithstanding the above, certain portions of our Service may contain mature contents not suitable for anyone younger than the Legal Age or 18 years of age. We will require that you confirm that you are of Legal Age or 18 years of age or older to access such content. If you enter any portion of the Service which is intended for or is marked for mature audiences only, you are certifying that you are of Legal Age or at least 18 years old and have the legal right to access such content. We shall not be responsible in any way for your failure to accurately confirm your age per the terms hereunder."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.5 When creating an Account and a user identity (“User ID”) you agree to (i) provide true, accurate, current and complete information as requested in the required fields (the “Account Information”) and (ii) promptly maintain and update such User ID and your Account Information to keep it true, accurate, current and complete."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.6 You, as creator of your Account and User ID, are solely responsible for your User ID. We will not tolerate offensive or obscene User IDs. If a User ID violates any part of these terms, we may immediately, temporarily, or permanently ban such a User ID, with or without notice."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.7 Your Account may only to be used by you. We are not responsible for any misuse of your Account or your User ID, you agree to accept all risks of misuse of and unauthorized access to your Account and to hold us and our affiliates harmless from and against any misuse use of your Account or your User ID, including, but not limited to, improper or unauthorized use by someone to whom you revealed your password."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.8 Please note that, you are responsible for maintaining the confidentiality and security of your User ID and password at all times, and you agree to notify us if your password is lost, stolen, or disclosed to an unauthorized third party, or otherwise may have been compromised. You are solely responsible for all activities and transactions that occur under your Account, and we are not responsible for any misuse use of your account, including without limitation in the event that your password is stolen or revealed to a third party and/or used for transactions. You agree to immediately notify us of any misuse use of your Account or any other breach of security in relation to the Service known to you. We provide you with choice to change your password in order to safeguard your Account."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "4.9 Your Account may be terminated if you do not use your Account within twelve months after the date that it was created or for any continuous period of twelve months. If you do not use your Account for any continuous period of twelve or more months, it may be terminated by us at our sole discretion."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "5.0 We will endeavour to notify you by email before we terminate your Account, unless we are terminating, deactivating or deleting your Account or User ID for a violation of these Terms or discontinuation of the Service. However, we will not be liable in any manner for any failure to give notice. If you advise us within five days of the notice that you want to keep your Account active, we will not terminate it. If you do not so notify us, your Account will be terminated and may be permanently deleted, along with your User ID, records, ranks and service information."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "5.1 Termination of your Account also entails the termination of the license to use the Service and Proprietary Materials, or any part thereof."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "5.2 Please note that regardless of any notice, we reserve the right to discontinue the Service or to terminate or suspend your Account at any time in our sole discretion, for any reason, or for no reason."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            5 Proprietary Rights\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "5.1 AMWGE is the owner of the Website, the Games, the Software and the Service, which are protected by US and international law including copyright laws. All rights and title in and to the Website, the Game, the Software and the Service, all features and content thereof (including without limitation any user accounts, titles, computer code, files, game software, client and server software, tools, patches, updates, themes, objects, characters, character names, stories, storylines, objects, content, text, dialogue, catch phrases, themes, locations, concepts, artwork, designs, graphics, pictures, video, animation, sounds, music, musical, compositions, sound recordings, audio-visual effects, information, data, documentation, “applets”, chat transcripts, character profile information, game play, recordings, in game items, in game activities, coin and Zushin Points) and the selection and arrangement thereof (collectively the “Proprietary Materials”) are the proprietary property of AMWGE or its licensors and are protected by U.S. and international copyright and other proprietary rights laws."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "5.2 In the event that you make any modifications, adaptations or derivative works of any kind to the Proprietary Materials (the “Modifications”), whether authorized or unauthorized, you understand and agree that you shall retain no rights of any kind in and to such Modifications and that all rights therein shall belong solely to AMWGE. You hereby irrevocably assign (and agree to assign) and transfer to AMWGE, free and clear of any restrictions or encumbrances, without any compensation beyond the consideration provided herein, any and all rights, title and interest that you may have in and to such Modifications. This assignment includes, without limitation, all worldwide copyrights and patent rights in and to such Modifications and the right to sue for past and future infringements. You hereby agree to cooperate with AMWGE in connection with the protection thereof and shall execute such documents (like further deed of transfer or assignment), if any, as needed by AMWGE to perfect its rights hereunder."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "5.3 Further, to the extent the assignments mentioned in paragraph 5.2 do not transfer any ownership interest in or to the Modifications, you expressly grant to AMWGE, us and our licensors all consents, clearances and a non-exclusive, perpetual, worldwide, complete, sub licensable and irrevocable right to make, use, sell, offer for sale, import or otherwise exploit, re-post, publish, use, quote, adapt, translate, archive, store, reproduce, modify, create derivative works from, syndicate, license, print, sublicense, distribute, transmit, broadcast, otherwise communicate, and publicly display and perform the Modifications, or any portion thereof, in any manner or form and in any medium or forum, whether now known or hereafter devised, without notice, acknowledgment or compensation to you. You waive and agree not to assert any moral or similar rights you may have in the Modifications for as far as is possible by applicable mandatory law."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            6 Privacy\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "6.1 Please review our Privacy Policy and Cookie Policy, for information regarding the collection, use and distribution of personal information. The Privacy Policy is published on the following Website: Privacy Policy. The Cookie Policy is published on the following Website: Cookie Policy You understand and agree that we may collect, use and disclose information as described in the Privacy Policy and Cookie Policy."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "6.2 You understand and agree that we may access, disclose or preserve personal information, including the content of your communications, in the good faith belief that we are lawfully authorized or required to do so, or that doing so is reasonably necessary or appropriate to comply with the law or with legal process or authorities, respond to any claims, or to protect the rights, property or safety of Gods of Zushin, our users, our employees or the public, including without limitation to protect Gods of Zushin or our users from fraudulent, abusive, inappropriate or unlawful use of our Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            7 Game Updates\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "7.1 When we update or “patch” any of our Games, we may utilize a patch routine to verify whether the most recent version of the client software is installed on your computer. If not, the most recent version may automatically be uploaded to your computer, and you hereby consent to, and waive any further notice of, such upload."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            8 Monitoring\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "8.1 You understand and agree that when you communicate with other players within a game or utilize any interactive features available on the Website, such as instant messaging, forums or chat rooms, such communications and postings are transmitted through our servers, and we may, but are not obligated to, monitor all such communications and postings, including those that are designated as “private.” You acknowledge that you have no expectation of privacy with respect to any such communications or postings, and you expressly consent to such monitoring."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            9 Device Identifiers\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "9.1 You understand and agree that when you access the Service by or through a mobile device (including but not limited to smart-phones or tablets), we can and may access, collect, monitor and/or remotely store one or more “device identifiers,” such as a universally unique identifier (“UUID”). Device identifiers are small data files or similar data structures stored on or associated with your mobile device, which uniquely identify your mobile device. A device identifier may be data stored in connection with the device hardware, data stored in connection with the device’s operating system or other software, or data sent to the device by us. A device identifier may convey information to us about how you browse and use the Service. A device identifier may remain persistently on your device, to help you log in faster and enhance your navigation through the Service. Some features of the Service may not function properly if use or availability of device identifiers is impaired or disabled."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            10 User Identifiers\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "10.1 You understand and agree that when you access the Service, we can and may access, collect, monitor and/or remotely store one or more “user identifiers.” User identifiers are small data files or similar data structure assigned to a user that will be used to enable you to continue in-game progress, use games across multiple platforms and help associate your identity across multiple platforms. A user identifier may convey information to us about how you browse and use the Service. A user identifier may remain persistently on your device or computer, to help you log in faster and enhance your navigation through the Service. Some features of the Service may not function properly if use or availability of user identifiers is impaired or disabled."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            11 Location Data\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "11.1 You understand and agree that when you access the Service by or through a mobile device, we can and may access, collect, monitor and/or remotely store “location data,” which may include GPS coordinates (e.g. latitude and/or longitude) or similar information regarding the location of your mobile device. Location data may convey to us information about how you browse and use the Service. Some features of the Service, particularly location-based services, may not function properly if use or availability of location data is impaired or disabled."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            12 Data Collected To Prevent Cheating And Unauthorized Software\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "12.1 You understand and agree that when user our Service and/or run our Game software, this can and may involve software functions designed to detect cheating or unauthorized and malicious programs. In this context, we may access, collect, monitor and/or remotely store screenshots of game play, information relating to hardware capacity, modifications related to our Game software, signatures, profiles or names of known unauthorized or malicious third party programs, files or processes that enable or facilitate cheating, unfair advantage or hacking of the Games or Service. If unauthorized or malicious programs are detected, the Game software may also communicate to us the users account and User ID and information about the unauthorized or malicious program or its use."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            13 Push Notification & Local Notification\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "13.1 You understand and agree that we may, with your consent, send push notifications and local notifications to your mobile device to provide game updates and other relevant messages."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            14 License\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "14.1 Subject to these Terms and any applicable EULA, we grant to you, for your non-commercial and personal use only, a limited, non-exclusive, revocable, non-transferable and non-sublicensable license to access and use the Service and the Proprietary Materials."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "14.2 Except as expressly permitted in these Terms or in the applicable EULA, such license does not include, and you agree not to engage in, any: (a) resale, sublicense, lending or commercial use of the Service or the Proprietary Materials therein; (b) distribution, public performance or public display of any Proprietary Materials except in connection with game play in the ordinary course, (d) modifying, adapting, altering, enhancing, or otherwise making any derivative uses of any Games, game content or other Proprietary Materials, or any portion thereof ; (e) use of any data mining, robots or similar data gathering or extraction methods; (f) downloading (other than the page caching) of any portion of the Proprietary Materials or any information contained therein, except as expressly permitted on the Website; (g) reverse engineer or decompile the Proprietary Materials, or otherwise attempt to derive source code from the Games or other software included in the Proprietary Materials; (h) any use of the Services or the Proprietary Materials other than for its intended purpose."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "14.3 Any use of the Service or the Proprietary Materials other than as specifically authorized herein, without the prior written permission of us is strictly prohibited and will, at AMWGE’s option, terminate the license granted herein. Such unauthorized use may also violate applicable laws including without limitation copyright and trademark laws and applicable communications regulations and statutes. Unless explicitly stated herein, nothing in these Terms shall be construed as conferring any license to or rights in intellectual property rights, whether by estoppel, implication or otherwise. This license is revocable at any time with or without cause."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            15 User Conduct\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "15.1 You must observe these Terms, all Rules of Conduct, all applicable laws and all basic rules of etiquette and common courtesy when using the Service. Any conduct that violates the law in an offline, real world community is also a violation of these terms. We will not tolerate any illegal or offensive conduct."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v(
                          "15.2 Without limiting the foregoing, in addition to the User Content rules set forth in Section 16, you agree not to take any of the following actions"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [_vm._v("a. harm minors in any way;")]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "b. impersonate any person or entity, including any AMWGE officials, forum leaders, guides, hosts, employees or agents, or falsely state or otherwise misrepresent your affiliation with a person or entity;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "c. forge headers or otherwise manipulate identifiers in order to disguise the origin of any message transmitted through the Website;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "d. upload, post, e-mail, transmit or otherwise make available any unsolicited or unauthorized advertising, promotional materials, “junk mail”, “spam”, “chain letters”, “pyramid schemes”, or any other form of solicitation;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "e. interfere with or disrupt the Service or servers or networks connected to the Service, or disobey any requirements, procedures, policies or regulations of networks connected to the Service;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "f. “stalk,” threaten or otherwise harass or cause discomfort to another;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "g. collect, store, post or otherwise disseminate any personal data about other users;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "h. impede or disrupt the Service or the normal flow of game play or dialogue in the Game or in Interactive Areas (defined below) in the Service or use vulgar language, abusiveness, use of excessive shouting (ALL CAPS), “spamming” or any other disruptive or detrimental methods in an attempt to disturb other users or our employees;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "i. engage in, encourage, or promote any illegal activity, or any activity that violates these Terms or the Rules of Conduct;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "j. engage in any actions that defraud or attempt to defraud, scam or cheat others out of any items that have been earned through authorized game play;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "k. cheat or utilize unauthorized exploits in connection with the Games or the Service;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "l. using or exploiting any bugs, errors, or design flaws to obtain unauthorized access to the Service or to gain an unfair advantage over other players;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "m. trade, sell, auction or otherwise transfer any virtual items or goods of any nature outside the game;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "n. take any action that disrupts the Service or that negatively affects or may prohibit other users from enjoying the Website, the Games or any other aspect of the Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "15.3 We may take any actions and impose any penalties we deem necessary to discourage and punish any violation of these terms or any other illegal or inappropriate conduct, all without prior notice or warning. The determination as to whether a violation has occurred and who is responsible for such act is solely within our discretion, and is based on what we deem best for the community and the Service. By using the Service, you agree you will be bound by our determination as to whether a violation has occurred and any penalty we choose to implement."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            16 User Content\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.1 The Service may include discussion forums, chat rooms, user feedback, messaging features, comments and other interactive areas or services (“Interactive Areas”) in which you or other users create, post, send or store any content, messages, materials, data, information, text, music, sound, photos, video, graphics, code or other items or materials on or through the Website (the “User Content”)."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.2 User Content posted to the Website is publicly available and not confidential, and will become the sole property of AMWGE. We strongly recommend that you not publish any personal information about yourself or others."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.3 You are solely responsible for the User Content you post and for your use of the Service including Interactive Areas."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v(
                          "16.4 You agree not to post, upload to, transmit, distribute, store, create or otherwise publish any of the following:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "a. User Content that is unlawful, libelous, defamatory, obscene, pornographic, indecent, lewd, suggestive, harassing, threatening, invasive of privacy or publicity rights, abusive, inflammatory, fraudulent or otherwise objectionable;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "b. User Content that would constitute, encourage or provide instructions for a criminal offense, violate the rights of any party, or that would otherwise create liability or violate any local, state, national or international law;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "c. User Content that may infringe any patent, trademark, trade secret, copyright or other intellectual or proprietary right of any party. By posting any User Content, you represent and warrant that you have the lawful right to distribute and reproduce such User Content;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "d. User Content that impersonates any person or entity or otherwise misrepresents your affiliation with a person or entity;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "e. unsolicited promotions, political campaigning, advertising or solicitations;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "f. Private information of any third party, including, without limitation, addresses, phone numbers, email addresses, Social Security numbers and credit card numbers;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "g. viruses, corrupted data or other harmful, disruptive or destructive files;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "h. User Content that violates the Rules of Conduct or that, in our sole judgment, is objectionable or which restricts or inhibits any other person from using or enjoying the Service, or which may expose us or our users to any harm or liability of any type."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.5 We take no responsibility and assume no liability for any User Content posted, stored or uploaded by you or any third party, or for any loss or damage thereto, nor are we liable for any mistakes, defamation, slander, libel, omissions, falsehoods, obscenity, pornography or profanity you may encounter. Your use of the Service including the Interactive Areas is at your own risk. As a provider of interactive services, we are not liable for any statements, representations or User Content provided by users in any public forum, personal home page or other Interactive Area. Although we have no obligation to screen, edit or monitor any of the User Content, we reserve the right, and have absolute discretion, to remove, screen or edit any User Content posted or stored at any time and for any reason without notice."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.6 You are solely responsible for creating backup copies of and replacing any User Content you post or store at your sole cost and expense. Any use of the Service including the Interactive Areas or other portions thereof in violation of the foregoing violates these Terms and may result in, among other things, termination or suspension of your rights to use the Service or any part thereof."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.7 You represent and warrant that (a) you own and control all of the rights to the User Content that you post or you otherwise have the right to post such User Content to the Site; (b) the User Content is accurate and not misleading; and (c) use and posting of the User Content you supply does not violate these Terms or the Rules of Conduct and will not violate any rights of or cause injury to any person or entity. You shall be solely liable for all royalties, fees, damages and any other monies resulting from any infringement of such right or any other harm resulting from any User Content you provide."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.8 In consideration of your use of the Service and for as far as is possible and permitted by applicable mandatory law, you hereby irrevocably transfer and assign (and agree to assign) to AMWGE all right, title and interest in and to the User Content you create, post, store or transmit on or through the Service, including all intellectual property rights therein. If said assignment and transfer to AMWGE is not possible according to applicable mandatory law, you hereby agree that all rights, title and interest are assigned and transferred to AMWGE. You hereby agree to cooperate with AMWGE and/or AMWGE in connection with the protection thereof and shall execute such documents (like further deeds of transfer or assignment), if any, as needed by AMWGE and/or AMWGE to perfect its rights hereunder."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "16.9 To the extent the foregoing assignments do not transfer any ownership interest in or to the User Content, you expressly grant to us and our licensors all consents, clearances and a non-exclusive, perpetual, worldwide, complete, sub licensable and irrevocable right to re-post, publish, use, quote, adapt, translate, archive, store, reproduce, modify, create derivative works from, syndicate, license, print, sublicense, distribute, transmit, broadcast, otherwise communicate, and publicly display and perform, make, use, sell, offer for sale, import or otherwise exploit the User Content, or any portion thereof, in any manner or form and in any medium or forum, whether now known or hereafter devised, without notice, acknowledgment or compensation to you. You waive and agree not to assert any moral or similar rights you may have in User Content."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            16 Designation of Agent to Receive Notification of Claimed Infringement of Copyright(s). DMCA Notices.\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v(
                          "17.1 If you believe that anything in the Service infringes upon any copyright which you own or control, you may file a notification of such infringement to the contact information set below:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [_vm._v("RedArc Studio, Ltd")]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Address: Intershore Chambers, Road Town, Tortola, VG1110, British Virgin Islands"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Electronic Mail Address (Email): amwgoz@goz.fun"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "17.2 We may give notice of a claim of copyright infringement to our users by means of a general notice on the Website, electronic mail to a user's email address in our records, or by written communication sent by first-class mail to a user's address in our records."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            18 Repeat infringer Policy\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "18.1 In accordance with the Digital Millennium Copyright Act (DMCA) and other applicable law, we have adopted a policy of terminating, in appropriate circumstances and at our sole discretion, subscribers or account holders who are deemed to be repeat infringers. We may also at its sole discretion limit access to the Service and/or terminate the Accounts of any users who infringe any intellectual property rights of others, whether or not there is any repeat infringement."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            19 Hyperlinks\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "19.1 You are granted a limited, non-exclusive right to create a text hyperlink to the Website for non-commercial purposes, provided such link does not portray us or any of our products and services in a false, misleading, derogatory or otherwise defamatory manner and provided further that the linking site does not contain any adult or illegal material or any material that is offensive, harassing or otherwise objectionable. This limited right may be revoked at any time. You may not use a AMWGE logo or other proprietary graphic of AMWGE to link to this Website without the express written permission of us. Further, you may not use, frame or utilize framing techniques to enclose any AMWGE trademark, logo or other proprietary information, including the images found at the Services, the content of any text or the layout/design of any page or form contained on a page on the Website without our express written consent. Except as noted above, you are not conveyed any right or license by implication, estoppel or otherwise in or under any patent, trademark, copyright or proprietary right of AMWGE or any third party."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "19.2 We make no claim or representation regarding, and accept no responsibility for, the quality, content, nature or reliability of third-party websites accessible by hyperlink from the Website, or websites linking to the Website. Such sites are not under our control and we are not responsible for the contents of any linked website or any link contained in a linked website, or any review, changes or updates to such websites. We provide these links to you only as a convenience, and the inclusion of any link does not imply affiliation, endorsement or adoption by us of any site or any information contained therein. When you leave the Website, you should be aware that our terms and policies no longer govern. You should review the applicable terms and policies, including privacy and data gathering practices, of any site to which you navigate from the Website."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            20 Mobile Software\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "20.1 Mobile Software. We make available software to access the Service via a mobile device (“Mobile Software”). To use the Mobile Software you must have a mobile device that is compatible with the mobile Service. We do not warrant that the Mobile Software will be compatible with your mobile device. We hereby grant you a non-exclusive, non-transferable, revocable license to use a compiled code copy of the Mobile Software for one account on one mobile device owned or leased solely by you, for your personal use. You may not: (i) modify, disassemble, decompile or reverse engineer the Mobile Software, except to the extent that such restriction is expressly prohibited by law; (ii) rent, lease, loan, resell, sublicense, distribute or otherwise transfer the Mobile Software to any third party or use the Mobile Software to provide time sharing or similar services for any third party; (iii) make any copies of the Mobile Software; (iv) remove, circumvent, disable, damage or otherwise interfere with security-related features of the Mobile Software, features that prevent or restrict use or copying of any content accessible through the Mobile Software, or features that enforce limitations on use of the Mobile Software; or (v) delete the copyright and other proprietary rights notices on the Mobile Software. You acknowledge that we may from time to time issue upgraded versions of the Mobile Software, and may automatically electronically upgrade the version of the Mobile Software that you are using on your mobile device. You consent to such automatic upgrading on your mobile device, and agree that the terms and conditions of this Agreement will apply to all such upgrades. Any third-party code that may be incorporated in the Mobile Software is covered by the applicable open source or third-party license EULA, if any, authorizing use of such code. The foregoing license grant is not a sale of the Mobile Software or any copy thereof, and we or our third party partners or suppliers retain all right, title, and interest in the Mobile Software (and any copy thereof). Any attempt by you to transfer any of the rights, duties or obligations hereunder, except as expressly provided for in this Agreement, is void. We reserve all rights not expressly granted under this Agreement."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "20.2 Mobile Software from iTunes. The following applies to any Mobile Software you acquire from the iTunes Store (“iTunes-Sourced Software”): You acknowledge and agree that this Agreement is solely between you and AMWGE, not Apple, and that Apple has no responsibility for the iTunes-Sourced Software or content thereof. Your use of the iTunes-Sourced Software must comply with the App Store Terms of Service. You acknowledge that Apple has no obligation whatsoever to furnish any maintenance and support services with respect to the iTunes-Sourced Software. In the event of any failure of the iTunes-Sourced Software to conform to any applicable warranty, you may notify Apple, and Apple will refund the purchase price for the iTunes-Sourced Software to you; to the maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with respect to the iTunes-Sourced Software, and any other claims, losses, liabilities, damages, costs or expenses attributable to any failure to conform to any warranty will be solely governed by this Agreement and any law applicable to AMWGE as provider of the software. You acknowledge that Apple is not responsible for addressing any claims of you or any third party relating to the iTunes-Sourced Software or your possession and/or use of the iTunes-Sourced Software, including, but not limited to: (i) product liability claims; (ii) any claim that the iTunes-Sourced Software fails to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection or similar legislation; and all such claims are governed solely by this Agreement and any law applicable to AMWGE as provider of the software. You acknowledge that, in the event of any third party claim that the iTunes-Sourced Software or your possession and use of that iTunes-Sourced Software infringes that third party’s intellectual property rights, AMWGE, not Apple, will be solely responsible for the investigation, defense, settlement and discharge of any such intellectual property infringement claim to the extent required by this Agreement. You and AMWGE acknowledge and agree that Apple, and Apple’s subsidiaries, are third party beneficiaries of this Agreement as relates to your license of the iTunes-Sourced Software, and that, upon your acceptance of the terms and conditions of this Agreement, Apple will have the right (and will be deemed to have accepted the right) to enforce this Agreement as relates to your license of the iTunes-Sourced Software against you as a third party beneficiary thereof."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            21 Third Party Content\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "21.1 We may provide or make available third party content through the Service and may provide links to web pages and content of third parties (collectively the “Third Party Content”) as a service to those interested in this information. We do not monitor or have any control over any Third Party Content on third party websites. We do not endorse or adopt any Third Party Content and can make no guarantee as to its accuracy or completeness. We do not represent or warrant the accuracy of any information contained therein and undertake no responsibility to update or review any Third Party Content. Users use such Third Party Content contained therein at their own risk."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            22. Advertisements and promotions; Third-party products and Services\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "22.1 We may run advertisements and promotions from third parties through the Service or may otherwise provide information about or links to third-party products or services through the Service. Your business dealings or correspondence with, or participation in promotions of, such third parties, and any terms, conditions, warranties or representations associated with such dealings or promotions are solely between you and such third party. We are not responsible or liable for any loss or damage of any sort incurred as the result of any such dealings or promotions or as the result of the presence of such non-AMWGE advertisers or third party information. If you access a third party website from the Service, you do so at your own risk, and you understand that this Agreement and our Privacy Policy do not apply to your use of such sites. You expressly relieve Company from any and all liability arising from your use of any third-party website, service, or content."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            23 Official Service and Beta Testing\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "23.1 The Games are designed for play only as offered through our Service. You agree not to access, create or provide any other means through which the game may be played by others, such as through server emulators. You agree not to use any hardware or software, including but not limited to third party tools, or any other method of support which may in any way influence or give you an advantage in the use of the Services which is not authorized by us, including but not limited to the use of ‘bots’ and/or any other method by which the Service may be played automatically without human input. You acknowledge that you do not have the right to create, publish, distribute, create derivative works from or use any software programs, utilities, applications, emulators or tools derived from or created for the games, except that you may use the Software to the extent expressly permitted by these Terms and the applicable EULA. You may not take any action which imposes an unreasonable or disproportionately large load on our infrastructure. You do not have ownership of and may not sell, transfer, trade or auction any Accounts, characters, items, coin, Zushin Points or Proprietary Materials, nor may you assist others in doing so, except as expressly authorized by us. We do not recognize any transfers occurring outside of the Service of anything related to the Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "23.2 You may be given the opportunity to Beta test new games (“Beta Games”) and Website features. Your participation as a Beta tester is subject to the terms and conditions below."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "23.3 You acknowledge that the you are using a preliminary, preview edition of the Websites features and the Beta Games and that you are participating in a beta test thereof (the “Beta Test”), and that the Beta Games site Website features may contain bugs, may not operate properly or perform all intended functions, may interfere with the functioning of other software applications, and may cause errors, data loss or other problems. Closed Beta Tests are confidential, and you agree to that all information about the Beta Games, the Services and the Beta Test, including without limitation any comments, ideas or other feedback (collectively the “Feedback”) you provide to AMWGE regarding the Beta Games, the Service or the Beta Test, shall be treated as confidential (the “Confidential Information”). You agree not to use the Confidential Information in any manner, except for your personal use for the sole purpose of testing the Beta Games and Website features, and you agree to prevent and protect the Confidential Information, or any part thereof, from disclosure to any person. You further agree to take all steps reasonably necessary to protect the secrecy of the Confidential Information and to prevent the Confidential Information from falling into the public domain or into the possession of unauthorized persons. All Confidential Information shall remain the sole property of AMWGE, and AMWGE may use such Confidential Information for any purpose without any obligation to you. You will carry out the testing personally and not provide access to Beta Games to any other person. You agree that breach of the above confidentiality obligations will cause irreparable harm to us, and we are entitled to (in addition to any other remedies available to it) ex parte injunctive relief without bond to prevent the breach or threatened breach of your obligations. Your obligation to keep the Beta Games confidential will continue until we publicly distribute, or have otherwise disclosed to the public through no fault of yours, each of the games and the content that you are testing."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "23.4 As a Beta tester, you are invited to play Beta Games for the sole purpose of evaluating the games and identifying errors. Nothing in these Terms, or on the Website or through the Service, shall be construed as granting you any rights or privileges of any kind with respect to the Beta Games or content that you find here. The Beta Games are provided for testing on an “as is,” “as available” basis and we make no warranty to you of any kind, express or implied. You understand and agree that playing Beta Games is at your own risk, that you know that the Beta Games may include known or unknown bugs, and that we have no obligations to you with respect to Beta Games, including without limitation any obligation to provide such games to you in the future at no charge."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "23.5 When playing some Beta Games, you may accumulate treasure, experience points, equipment, or other value or status indicators within the Beta test. This data may be reset at any time during the testing process, and it may be reset when the particular game completes this testing phase. In this case, all player history and data will be erased and each player will return to novice status."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            24 Fees\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "24.1 We may charge fees to access and acquire certain game items or participate in game activities through the Service and may allow the purchase of in game “points” that may be applied to the purchase of in game items or activities (“Zushin Points”). After the purchase you will directly have the right to use Zushin Points and be able to it in the way as is stipulated."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "24.2 ANY APPLICABLE ZUSHIN POINTS, FEES AND OTHER CHARGES ARE PAYABLE IN ADVANCE AND NON REFUNDABLE. ZUSHIN POINTS HAVE NO MONETARY VALUE AND CANNOT BE REDEEMED FOR CASH. ZUSHIN POINTS AND THE RIGHT TO USE APPLICABLE ZUSHIN POINTS ARE NON-TRANSFERABLE, IN WHOLE OR PART. THE RIGHT TO USE ZUSHIN POINTS IS AN INTEGRAL PART OF THE LICENSE TO USE THE SERVICE AND GAME."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "24.3 You explicitly acknowledge and agree that the a right to use (license) Zushin Points starts from the moment fees have been paid and that you are able from that moment to use Zushin Points for the intended purpose. You explicitly acknowledge and agree that you lose the right to withdraw from the purchase of Zushin Points."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "24.4 We may, from time to time, modify, amend, or supplement our fees, billing methods and terms applicable to Zushin Points or to any purchases, and post those changes in these Terms, in separate Terms of Sale or in other terms or agreements posted on the Website or Service or otherwise provided to you by us. Such modifications, amendments, supplements or Terms of Sale shall be effective immediately upon posting on the Website or Service and shall be incorporated by reference into these Terms. If any change is unacceptable to you, you may terminate your account at any time."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "25.5 If you claim a chargeback for any reason, we have the right to investigate and dispute such chargeback. If we believe that your chargeback requirement is spurious, unreasonable, or invalid, we may take the dispute to court. If your chargeback is deemed invalid in court, you agree to pay for all fees and costs resulting from the disputed chargeback, including but not limited to legal fees and expenses, damages, monies lost due to non-operation, and chargeback fees, or if applicable mandatory law dictates otherwise, to the maximum amount permitted."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "25.6 You may pay for any applicable fees and charges or for Zushin Points by major credit card, PayPal® or other such methods authorized by us."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "25.7 We are not liable for “hacking” or lost of your virtual goods from your account, however, we may, in our sole discretion, reimburse virtual goods or Zushin Points upon proof that such loss was not due to your inappropriate use. We may limit the quantity of any item or refuse to provide you with any virtual good. Verification of certain information applicable to a transaction may be required prior to our acceptance of your payment. Price and availability of virtual goods are subject to change with no notice. We have no liability with respect to virtual goods or Zushin Points that is gifted to you or provided as an incentive."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            25 Interruption of Service\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "25.1 We reserve the right to interrupt the Service or any part thereof from time to time on a regularly scheduled basis or otherwise with or without prior notice in order to perform maintenance. You agree that we will not be liable for any interruption of the Service or any part thereof, delay or failure to perform resulting from any causes whatsoever."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "25.2 You acknowledge that the Service or any part thereof may be interrupted for reasons beyond our control, and we cannot guarantee that you will be able to access the Service whenever you may wish to do so. We shall not be liable for any interruption of the Services, delay or failure to perform resulting from any causes whatsoever."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "25.3 We have the right at any time with or without reason to change and/or eliminate any aspect(s) of the Service as we see fit in our sole discretion."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "25.4 We are not obligated to refund all or any portion of any Account fee (if any), by reason of any interruption of the Service by reason of any of the circumstances described in paragraphs 25.1, 25.2."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            26 Disciplinary Action / Account & Service Termination\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "26.1 FOR ANY REASON WE MAY SUSPEND, TERMINATE, MODIFY, BLOCK ACCESS TO OR DELETE THE SERVICE OR ANY ACCOUNT OR PART THEREOF, BY GIVING YOU NOTICE OF SUCH WITHIN THE TIME PERIOD SPECIFIED WHEN YOU CREATED AN ACCOUNT OR JOINED A SERVICE, OR IF NO SUCH TIME PERIOD WAS SPECIFIED, THEN WITHIN THIRTY (30) DAYS OF THE DATE SUCH NOTICE IS PROVIDED TO YOU BY EMAIL OR IS POSTED ON THE WEBSITE OR INTERACTIVE AREA BY US."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "26.2 For user violations we may at our option issue warnings and temporary suspensions and permanent terminations of Accounts. We retain the sole discretion as to when and how to impose warnings, penalties and/or disciplinary actions. We consider the severity of the violation and the number of infractions in making our determination; however, any determination shall be under our absolute discretion."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "27.3 For the avoidance of doubt, you hereby acknowledge that we have the sole discretion with respect to termination of your Account, even if there are credits remaining on your Account. The termination of your Account entails the termination of the license to use the Service or any part thereof (see section 8)."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "27.4 You have the right to terminate your Account at any time by delivering notice to us. You understand and agree that, unless applicable mandatory law dictates otherwise, the termination of your Account is your sole right and remedy with respect to any dispute, including, but not limited to, any related to, or arising out of: (i) any term of this Agreement or our enforcement or application of this Agreement; (ii) the User Contents; (iii) your ability to access and/or use the Service or the Website; or (iv) the amount or type of fees, surcharges, applicable taxes, billing methods, or any change to the fees, applicable taxes, surcharges or billing methods."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "27.5 You may terminate your Account by delivering notice to us. We reserve the right to collect accrued fees and charges and costs incurred by us before your termination. In addition, you are responsible for any fees, charges and costs incurred to third-party vendors or content providers before your termination."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "27.6 In the event your Account is terminated for any reason, or for no reason, no refund will be granted, no online time or other credits (e.g., points in an online game) will be credited to you or converted to cash or other form of reimbursement, and you will have no further access to your Account. Any delinquent or unpaid accounts or accounts with unresolved disputes must be settled before we may allow you to register again."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "27.7 If you feel you have been unfairly warned or disciplined, please contact us with a full detailed explanation."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            27 Indemnification\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "27.1 You agree to defend, indemnify and hold harmless AMWGE, its independent contractors, service providers and consultants, and their respective directors, employees, agents, partners, affiliates, and subsidiaries, from and against any claims, damages, costs, liabilities and expenses (including, but not limited to, reasonable attorneys’ fees) arising out of or related to any User Content you post, store or otherwise transmit on or through the Website, your conduct, your violations of these Terms, any misuse of the Service, or your violation of the rights of any third party."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            28 Acknowledgements\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v("28.1You hereby acknowledge and agree that:"),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(a) WHEN USING THE SERVICES, THE SOFTWARE MAY MONITOR YOUR COMPUTER’S RANDOM ACCESS MEMORY (RAM) AND/OR CPU PROCESSES FOR UNAUTHORIZED THIRD PARTY PROGRAMS RUNNING CONCURRENTLY WITH THE SOFTWARE. AN “UNAUTHORIZED THIRD PARTY PROGRAM” AS USED HEREIN SHALL BE DEFINED AS ANY THIRD PARTY SOFTWARE, INCLUDING WITHOUT LIMITATION ANY “ADD-ON” OR “MOD,” THAT IN AMWGE’S SOLE DETERMINATION: (i) ENABLES OR FACILITATES CHEATING OF ANY TYPE; (ii) ALLOWS USERS TO MODIFY OR HACK THE SOFTWARE INTERFACE, ENVIRONMENT, AND/OR EXPERIENCE IN ANY WAY NOT EXPRESSLY AUTHORIZED BY AMWGE; OR (iii) INTERCEPTS, “MINES,” OR OTHERWISE COLLECTS INFORMATION FROM OR THROUGH THE SOFTWARE. IN THE EVENT THAT THE SOFTWARE DETECTS AN UNAUTHORIZED THIRD PARTY PROGRAM, IT MAY COMMUNICATE INFORMATION BACK TO AMWGE, INCLUDING WITHOUT LIMITATION YOUR ACCOUNT NAME, DETAILS ABOUT THE UNAUTHORIZED THIRD PARTY PROGRAM DETECTED, AND THE TIME AND DATE THE UNAUTHORIZED THIRD PARTY PROGRAM WAS DETECTED; AND/OR AND RedArc Studio, Ltd, Ltd MAY EXERCISE ANY OR ALL OF ITS RIGHTS UNDER THIS SECTION OF THE AGREEMENT, WITH OR WITHOUT PRIOR NOTICE TO THE USER."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(b) AMWGE MAY MONITOR OR RECORD YOUR CHAT SESSIONS AND OTHER ELECTRONIC COMMUNICATION TRANSMITTED OR RECEIVED THROUGH THE GAME OR THE SERVICE AND YOU CONSENT TO SUCH MONITORING OR RECORDING."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(c) We do not guarantee the completeness, accuracy or correctness of any information passed between players.. We do not guarantee the safe keeping of information that is passed between players. You acknowledge that said information passed between users is ‘as is’ and that you will use such information only for your own risk."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(d) You acknowledge that in using the Service and/or Games, you may lose in-game features and/or items. You may not hold AMWGE responsible for any in-game feature or item loss. We do not guarantee the availability of any in-game items, any Service or any levels to players"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text"),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            29 Disclaimer of Warranties\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v("29.1 YOU EXPRESSLY UNDERSTAND AND AGREE THAT:"),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(a) THE SERVICE, THE GAMES, THE WEBSITE AND ALL MATERIALS CONTAINED THEREIN ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. AMWGE AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES, AGENTS, PARTNERS AND LICENSORS DISCLAIM ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, PERFORMANCE OR SUITABILITY FOR YOUR INTENDED USE, TITLE AND NON-INFRINGEMENT AS TO THE SERVICE, THE GAME AND THE WEBSITE, INCLUDING ALL INFORMATION, CONTENT AND MATERIALS CONTAINED THEREIN. WITHOUT LIMITING THE FOREGOING, AMWGE DOES NOT REPRESENT OR WARRANT THAT THE SERVICE, THE GAMES, THE WEBSITE OR THE MATERIALS CONTAINED THEREIN ARE ACCURATE, COMPLETE, RELIABLE, AVAILABLE, CURRENT OR ERROR-FREE. AMWGE ALSO DOES NOT REPRESENT OR WARRANT THAT THE GAMES, THE WEBSITE OR ITS SERVERS ARE FREE OF VIRUSES, BUGS, ERRORS OR OTHER HARMFUL COMPONENTS OR DEFECTS, TRANSMIT DATA IN A SECURE MANNER, OR FUNCTION PROPERLY WITH THE SERVICE."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(b) AMWGE AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES, AGENTS, PARTNERS AND LICENSORS MAKE NO WARRANTY THAT (i) THE SERVICE WILL MEET YOUR REQUIREMENTS; (ii) THE WEBSITE WILL BE UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE; OR (iii) ANY ERRORS IN THE SOFTWARE WILL BE CORRECTED."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(c) WHILE AMWGE ATTEMPTS TO MAKE YOUR ACCESS AND USE OF THE SERVICE SAFE, AMWGE CANNOT AND DOES NOT REPRESENT OR WARRANT THAT THE SERVICE OR ITS SERVER(S) ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS; THEREFORE, YOU SHOULD USE INDUSTRY-RECOGNIZED SOFTWARE TO DETECT AND DISINFECT VIRUSES FROM ANY DOWNLOAD. ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE WEBSITE OR SERVICE IS ACCESSED AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY SUCH MATERIAL."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(d) A SMALL PERCENTAGE OF USERS MAY EXPERIENCE EPILEPTIC SEIZURES WHEN EXPOSED TO CERTAIN LIGHT PATTERNS OR BACKGROUNDS ON A COMPUTER SCREEN OR WHILE USING THE WEBSITE OR THE SERVICE. CERTAIN CONDITIONS MAY INDUCE PREVIOUSLY UNDETECTED EPILEPTIC SYMPTOMS EVEN IN USERS WHO HAVE NO HISTORY OF PRIOR SEIZURES OR EPILEPSY. IF YOU, OR ANYONE IN YOUR FAMILY, HAVE AN EPILEPTIC CONDITION, CONSULT YOUR PHYSICIAN PRIOR TO USING THE SERVICE. IMMEDIATELY DISCONTINUE USE OF THE SERVICE AND CONSULT YOUR PHYSICIAN IF YOU EXPERIENCE ANY OF THE FOLLOWING SYMPTOMS WHILE USING THE SERVICE: DIZZINESS, ALTERED VISION, EYE OR MUSCLE TWITCHES, LOSS OF AWARENESS, DISORIENTATION, ANY INVOLUNTARY MOVEMENT, OR CONVULSIONS."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "(e) REFERENCE TO ANY PRODUCTS, SERVICES, PROCESSES OR OTHER INFORMATION, BY TRADE NAME, TRADEMARK, MANUFACTURER, SUPPLIER OR OTHERWISE DOES NOT CONSTITUTE OR IMPLY ENDORSEMENT, SPONSORSHIP OR RECOMMENDATION THEREOF, OR ANY AFFILIATION THEREWITH, BY AMWGE."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            30 Limitation of Liability\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "30.1 IN NO EVENT SHALL WE, AMWGE, ITS DIRECTORS, MEMBERS, AFFILIATES, SUBSIDIARIES, EMPLOYEES OR AGENTS BE LIABLE FOR ANY DIRECT, SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES, OR ANY OTHER DAMAGES OF ANY KIND, INCLUDING BUT NOT LIMITED TO LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN AN ACTION IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR OTHERWISE, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OF OR INABILITY TO USE THE WEBSITE, THE SERVICE, THE GAMES OR ANY OF THE CONTENT OR THE MATERIALS CONTAINED IN OR ACCESSED THROUGH THE WEBSITE OR THE SERVICE, INCLUDING WITHOUT LIMITATION ANY DAMAGES CASED BY OR RESULTING FROM RELIANCE BY USER ON ANY INFORMATION OBTAINED FROM US OR AMWGE, OR THAT RESULT FROM MISTAKES, OMISSIONS, INTERRUPTIONS, DELETION OF FILES OR EMAIL, ERRORS, DEFECTS, VIRUSES, DELAYS IN OPERATION OR TRANSMISSION OR ANY FAILURE OF PERFORMANCE, WHETHER OR NOT RESULTING FROM ACTS OF GOD, COMMUNICATIONS FAILURE, THEFT, DESTRUCTION OR UNAUTHORIZED ACCESS TO AMWGE’S RECORDS, PROGRAMS OR SERVICES."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "30.2 IN NO EVENT SHALL THE AGGREGATE LIABILITY OF AMWGE, WHETHER IN CONTRACT, WARRANTY, TORT (INCLUDING NEGLIGENCE, WHETHER ACTIVE, PASSIVE OR IMPUTED), PRODUCT LIABILITY, STRICT LIABILITY OR OTHER THEORY, ARISING OUT OF OR RELATING TO THE USE OF OR INABILITY TO USE THE SERVICE, THE WEBSITE OR ANY OF THE GAMES EXCEED ANY COMPENSATION YOU PAY, IF ANY, TO AMWGE FOR ACCESS TO OR USE THEREOF."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "30.3 Some member states in the EU do not allow the foregoing limitations of liability by (mandatory) law, so they may not apply to you. In such case you explicitly agree that our (or any such other released parties) liability to you shall be limited to the maximum extent permitted by applicable mandatory law. You agree that we cannot be held responsible or liable for anything that occurs or results from accessing or subscribing to the Service."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            31 General\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v(
                          "31.1 Unless applicable mandatory law expressly dictates otherwise:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "- This Agreement is governed by and shall be construed and enforced under the laws of British Virigin Islands;"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "- Any action, dispute or proceeding instituted under this Agreement shall be brought before the competent court in British Virigin Islands."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "31.2 Our failure to act with respect to a breach by you or others does not waive our right to act with respect to subsequent or similar breaches."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "31.3 Except as otherwise permitted herein, you may not assign or transfer this Agreement or your rights hereunder, or the Games or any other software provided by us, and any attempt to the contrary is void."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "31.4 If any provision of this Agreement shall be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from this Agreement and shall not affect the validity and enforceability of any remaining provisions."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "31.5 The section headings used herein are for reference only and shall not be read to have any legal effect."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            32 Foundry terms of user\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          '32.1 The Program game LithTech ("LithTech" or “Game”) contains certain design, programming and processing utilities, tools, assets and other resources ("The Foundry") for use with the Program Game that allow you to create customized new game levels and other related game materials for personal use in connection with the Program Game ("New Game Materials"). The You agree that your use of the Foundry is subject to the Terms of Service and the following additional license restrictions:'
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "32.2 New Game Materials may be created only if such New Game Materials can be used exclusively in combination with the online version of the ProgramGame. New Game Materials may not be designed to be used as a stand-alone product. New Game Materials you create using the Foundry are subject to the following rules and restrictions:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "32.3 Other Prohibited uses of New Game Materials published using The Foundry:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You may not use New Game Materials to endorse or oppose any political party, association (e.g., Republican, Democrat, candidates, or otherwise) or any side of any issue."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You may not use New Game Materials to depict a likeness of any real person (historical or present day)."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You may not use New Game Materials to advertise any businesses, products or services of any party."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v("You may not publish web URLs in your content."),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You may not use New Game Materials to convey any profanity, vulgarity, hate language, explicit sexual language, derogatory references to race, gender, religion, age, mental or physical impairment, obesity or sexual orientation, or reference any drugs (legal or illicit) or medication."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You may not make use of any copyrighted or trademarked material of third parties, without obtaining irrevocable, written licenses granted specifically for that purpose."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You may not use New Game Materials to exploit the design of the The ProgramGame."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You may not use New Game Materials to infringe on the rights of privacy and or publicity of third parties."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "32.4 RedArc Studio, Ltd reserves the right to remove any New Game Materials for any reason at any time, without providing cause or recompense."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "32.5 You understand and agree that you shall retain no rights of any kind in and to New Game Materials produced using the Foundry and that all New Game Materials and all rights therein shall belong solely to RedArc Studio, Ltd, to use as it sees fit. You hereby irrevocably assign (and agree to assign) and transfer to RedArc Studio, Ltd, free and clear of any restrictions or encumbrances, without any compensation beyond the consideration provided herein, any and all rights, title and interest that you may have in and to such New Game Materials. This assignment includes, without limitation, all worldwide copyrights and patent rights in and to such New Game Materials and the right to sue for past and future infringements. You hereby agree to cooperate with RedArc Studio, Ltd in connection with the protection thereof and shall execute such documents (like further deed of transfer or assignment), if any, as needed by RedArc Studio, Ltd to perfect its rights hereunder."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "32.6 Further, to the extent the assignments mentioned herein do not transfer any ownership interest in or to the New Game Materials, you expressly grant to us and our licensors all consents, clearances and a non-exclusive, perpetual, worldwide, complete, sublicensable and irrevocable right to make, use, sell, offer for sale, import or otherwise exploit, re-post, publish, use, quote, adapt, translate, archive, store, reproduce, modify, create derivative works from, syndicate, license, print, sublicense, distribute, transmit, broadcast, otherwise communicate, and publicly display and perform the New Game Materials, or any portion thereof, in any manner or form and in any medium or forum, whether now known or hereafter devised, without notice, acknowledgment or compensation to you. You waive and agree not to assert any moral or similar rights you may have in the New Game Materials."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "32.7 As a condition to your using the Foundry, you will not use or allow third parties to use the Foundry and the New Game Materials created by you for any commercial purposes, including but not limited to selling, renting, leasing, licensing, distributing, or otherwise transferring the ownership of such New Game Materials, whether on a standalone basis or packaged in combination with the New Game Materials created by others, through any and all distribution channels, including, without limitation, retail sales and on-line electronic distribution. You agree not to solicit, initiate or encourage any proposal or offer from any person or entity to create any New Game Materials for commercial distribution. You agree to promptly inform RedArc Studio, Ltd in writing of any instances of your receipt of any such proposal or offer. If you decide to make available the use of the New Game Materials created by you to other gamers, you agree to do so solely without charge."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            33 Remedies\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "You agree that your obligations and representations, and the license limitations, stated herein, are necessary and reasonable in order to protect AMWGE, its business, and its licensors, and you expressly agree that monetary damages would be inadequate to compensate AMWGE fully for any breach of this Agreement, or for any misrepresentation made by you above. Accordingly, you agree and acknowledge that any such violation or threatened violation will cause irreparable injury to AMWGE and that, in addition to any other remedies that may be available, in law, in equity or otherwise, AMWGE shall be entitled to obtain injunctive relief against the breach or threatened breach of this Agreement, or the continuation of any such breach by you, or to remedy any misrepresentation made by you, without the necessity of proving the inadequacy of any legal remedy or monetary damages, and without the need to post any bond."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            34 Independent Contractors.\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "34.1 You acknowledge that you are not considered, and shall not present yourself as, an agent, employee, joint venturer, or partner of AMWGE (or any of its respective affiliates, publishing partners, licensors or licensees). Each party to this Agreement is an independent contractor with respect to the other, and nothing in this Agreement will be deemed to place the parties in the relationship of employer-employee, principal-agent, partners or joint venturers."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            35 Closing\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Thank you again for visiting us. We hope you enjoy your stay and take full advantage of the online community we are developing. Please remember that you are a guest and act with the same courtesy and respect you expect from other guests."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }